module.exports = __webpack_public_path__ + "news-image-01@2x.jpg?0a378f7d04452fd3f33918abc8ab35ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news-image-01@2x.jpg
// module id = 239
// module chunks = 0